import { Injectable } from "@angular/core";
import { HandlerEndPointService } from "./handler-endpoint";

@Injectable()
export class HandlerService {
  constructor(private handlerEndPoint: HandlerEndPointService) {
  }

  getData(filtro?) {
    return this.handlerEndPoint.getData(filtro);
  }


  postData(filtro?) {
    return this.handlerEndPoint.postData(filtro);
  }

}
